import React from 'react';

const IconTwitter = () => {
  return (
    <div>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.828461" width="40" height="40" rx="20" fill="black" />
        <path
          d="M29.5565 16.1793C29.5698 16.3728 29.5698 16.5663 29.5698 16.7616C29.5698 22.7122 25.0398 29.5751 16.7563 29.5751V29.5716C14.3093 29.5751 11.9132 28.8742 9.85327 27.5526C10.2091 27.5954 10.5667 27.6168 10.9252 27.6177C12.953 27.6195 14.9229 26.9391 16.5182 25.6862C14.5911 25.6496 12.9013 24.3932 12.3109 22.5588C12.986 22.689 13.6816 22.6623 14.3441 22.4813C12.2432 22.0568 10.7316 20.2109 10.7316 18.0671C10.7316 18.0475 10.7316 18.0288 10.7316 18.01C11.3577 18.3587 12.0586 18.5522 12.7755 18.5736C10.7967 17.2511 10.1868 14.6187 11.3817 12.5605C13.6682 15.374 17.0417 17.0844 20.6631 17.2654C20.3001 15.7013 20.7959 14.0623 21.9659 12.9627C23.7797 11.2577 26.6324 11.3451 28.3374 13.158C29.346 12.9592 30.3127 12.5891 31.1973 12.0647C30.8611 13.1072 30.1575 13.9927 29.2176 14.5554C30.1102 14.4502 30.9824 14.2112 31.8037 13.8465C31.1991 14.7525 30.4375 15.5417 29.5565 16.1793Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default IconTwitter;
